export default "/bundles/assets/spinner_67a23f99aae1d9e451fffa7a0d247cf3.gif";